import { logger } from '@fiverr-private/obs';
import pathfinder from '@fiverr-private/pathfinder';
import { type CustomAxiosConfig, maxios } from '../../lib/maxios/maxios';

const ENDPOINT = 'verify_custom_theme';

export const triggerStoreCreation = async (storeId: string): Promise<void> => {
    const url = pathfinder('ai_store_builder_api_post', {
        version: 'v1',
        store_id: storeId,
        endpoint: ENDPOINT,
    });

    const options: Partial<CustomAxiosConfig> = {
        routeKey: ENDPOINT,
    };

    try {
        await maxios.post(url, {}, options);
    } catch (error) {
        logger.error(error as Error, {
            description: 'Failed to trigger store creation',
            store_id: storeId,
        });

        throw error;
    }
};
